/**
 * HCEN IP — role permissions (standalone).
 * Each login sees ONLY these routes. Extend when adding modules.
 */
import { HMS_MODULES } from './config/modules';
export const ROLES = {
  manager: {
    id: 'manager',
    label: 'Manager / Owner',
    landing: '/manager/dashboard',
    color: '#8b5cf6',
  },
  reception: {
    id: 'reception',
    label: 'Reception',
    landing: '/reception/queue',
    color: '#4f8ef7',
  },
  doctor: {
    id: 'doctor',
    label: 'Doctor',
    landing: '/doctor/queue',
    color: '#00d4aa',
  },
  billing: {
    id: 'billing',
    label: 'Billing / Cashier',
    landing: '/billing/receipts',
    color: '#f59e0b',
  },
  ipd: {
    id: 'ipd',
    label: 'IP / Bed Coordinator',
    landing: '/ipd/list',
    color: '#f97316',
  },
  nurse: {
    id: 'nurse',
    label: 'Nurse',
    landing: '/nurse/station',
    color: '#ec4899',
  },
  pharmacy: {
    id: 'pharmacy',
    label: 'Pharmacy',
    landing: '/pharmacy/desk',
    color: '#10b981',
  },
  lab: {
    id: 'lab',
    label: 'Laboratory',
    landing: '/lab/orders',
    color: '#06b6d4',
  },
  hr: {
    id: 'hr',
    label: 'HR',
    landing: '/hr/dashboard',
    color: '#6366f1',
  },
  housekeeping: {
    id: 'housekeeping',
    label: 'Housekeeping',
    landing: '/hms/housekeeping',
    color: '#14b8a6',
  },
};

/** route path → allowed roles (manager always has *) */
export const ROUTE_ACCESS = {
  '/manager/dashboard': ['manager'],
  '/manager/admin': ['manager'],
  '/reception/queue': ['manager', 'reception'],
  '/reception/patients': ['manager', 'reception', 'doctor', 'lab'],
  '/doctor/queue': ['manager', 'doctor'],
  '/billing/receipts': ['manager', 'billing', 'reception', 'pharmacy'],
  '/billing/op': ['manager', 'billing', 'reception'],
  '/hms/analysis': ['manager', 'billing'],
  '/ipd/list': ['manager', 'ipd', 'nurse', 'doctor', 'reception', 'billing'],
  '/ipd/patient': ['manager', 'ipd', 'nurse', 'doctor', 'reception', 'billing'],
  '/ipd/admit': ['manager', 'ipd', 'reception'],
  '/ipd/beds': ['manager', 'ipd'],
  '/nurse/station': ['manager', 'nurse'],
  '/pharmacy/desk': ['manager', 'pharmacy'],
  '/lab/orders': ['manager', 'lab', 'doctor'],
  '/hms/rx-settings': ['manager', 'doctor'],
  '/hr/dashboard': ['manager', 'hr'],
  '/hr/leave': ['manager', 'hr', 'doctor', 'nurse', 'reception', 'billing', 'ipd', 'pharmacy', 'lab', 'housekeeping'],
  '/hr/staff': ['manager', 'hr'],
  '/staff/directory': ['manager', 'hr'],
  '/hms/maintenance': ['manager', 'nurse', 'doctor', 'reception', 'ipd', 'lab', 'pharmacy', 'housekeeping', 'billing', 'hr'],
  '/hms/housekeeping': ['manager', 'nurse', 'ipd', 'reception', 'housekeeping'],
  '/hms/roster': ['manager', 'hr'],
  '/hms/clinic-growth': ['manager'],
};

export const NAV_BY_ROLE = {
  manager: [
    { path: '/manager/dashboard', label: 'Dashboard', section: 'Overview' },
    { path: '/hms/analysis', label: 'Analytics & Reports', section: 'Overview' },
    { path: '/manager/admin', label: 'Staff & Logins', section: 'Admin' },
    // Clinical — OPD
    { path: '/reception/queue', label: 'Q Page', section: 'OPD' },
    { path: '/hms/appointments', label: 'Appointments', section: 'OPD' },
    { path: '/reception/patients', label: 'Patient Registry', section: 'OPD' },
    { path: '/doctor/queue', label: 'Doctor Queue', section: 'OPD' },
    { path: '/hms/emr', label: 'EMR / Records', section: 'OPD' },
    { path: '/hms/rx-settings', label: 'Rx pad settings', section: 'OPD' },
    // Inpatient
    { path: '/ipd/list', label: 'IPD List', section: 'Inpatient' },
    { path: '/ipd/admit', label: 'Admit Patient', section: 'Inpatient' },
    { path: '/ipd/beds', label: 'Bed Master', section: 'Inpatient' },
    { path: '/hms/discharge', label: 'Discharge Summary', section: 'Inpatient' },
    { path: '/nurse/station', label: 'Nursing Station', section: 'Inpatient' },
    { path: '/hms/diet', label: 'Diet & Nutrition', section: 'Inpatient' },
    // Diagnostics
    { path: '/pharmacy/desk', label: 'Pharmacy', section: 'Diagnostics' },
    { path: '/lab/orders', label: 'Laboratory', section: 'Diagnostics' },
    { path: '/hms/radiology', label: 'Radiology', section: 'Diagnostics' },
    // Specialty & compliance
    { path: '/hms/icu', label: 'ICU / Critical Care', section: 'Specialty' },
    { path: '/hms/nicu', label: 'NICU', section: 'Specialty' },
    { path: '/hms/dialysis', label: 'Dialysis Unit', section: 'Specialty' },
    { path: '/hms/physio', label: 'Physiotherapy', section: 'Specialty' },
    { path: '/hms/tpa', label: 'TPA / Insurance', section: 'Finance' },
    { path: '/hms/payroll', label: 'Payroll & Accounts', section: 'Finance' },
    // Surgical
    { path: '/hms/ot', label: 'OT Management', section: 'Surgical' },
    { path: '/hms/bloodbank', label: 'Blood Bank', section: 'Surgical' },
    // Finance & Store
    { path: '/billing/receipts', label: 'Billing & Payments', section: 'Finance' },
    { path: '/hms/store', label: 'Central Store / Inventory', section: 'Finance' },
    // Hospital Services
    { path: '/hms/feedback', label: 'Patient Feedback', section: 'Services' },
    { path: '/hms/clinic-growth', label: 'Clinic Growth', section: 'Services' },
    { path: '/hms/maintenance', label: 'Maintenance', section: 'Services' },
    { path: '/hms/sms', label: 'SMS / WhatsApp', section: 'Services' },
    { path: '/hms/ambulance', label: 'Ambulance', section: 'Services' },
    { path: '/hms/visitors', label: 'Visitor Management', section: 'Services' },
    { path: '/hms/housekeeping', label: 'Housekeeping', section: 'Services' },
    { path: '/hms/mortuary', label: 'Mortuary', section: 'Services' },
    { path: '/hms/quality', label: 'Quality / NABH', section: 'Compliance' },
    { path: '/hms/infection', label: 'Infection Control', section: 'Compliance' },
    { path: '/hms/bmw', label: 'Biomedical Waste', section: 'Compliance' },
    { path: '/hms/documents', label: 'Document Management', section: 'Compliance' },
    { path: '/hms/telemedicine', label: 'Telemedicine', section: 'Digital' },
    { path: '/hms/abha', label: 'ABHA / ABDM', section: 'Digital' },
    { path: '/hms/roster', label: 'Duty Roster', section: 'Admin' },
    // Admin
    { path: '/hr/dashboard', label: 'HR & Attendance', section: 'Admin' },
    { path: '/hms/settings', label: 'Settings', section: 'Admin' },
  ],
  reception: [
    { path: '/reception/queue', label: 'Q Page', section: 'Today' },
    { path: '/reception/patients', label: 'Patient Registry', section: 'Today' },
    { path: '/hms/appointments', label: 'Appointments', section: 'Today' },
    { path: '/hr/leave', label: 'Apply Leave', section: 'Self' },
    { path: '/billing/receipts', label: 'Billing & Receipts', section: 'Finance' },
    { path: '/ipd/list', label: 'IPD Patients', section: 'Finance' },
    { path: '/ipd/admit', label: 'Admit Patient', section: 'Finance' },
    { path: '/hms/sms', label: 'SMS / WhatsApp', section: 'Communication' },
    { path: '/hms/feedback', label: 'Patient Feedback', section: 'Quality' },
    { path: '/hms/maintenance', label: 'Report Issue', section: 'Facility' },
  ],
  doctor: [
    { path: '/doctor/queue', label: 'My OPD Queue', section: 'Consult' },
    { path: '/hms/emr', label: 'EMR / Records', section: 'Consult' },
    { path: '/hms/rx-settings', label: 'Rx pad settings', section: 'Consult' },
    { path: '/reception/patients', label: 'Patient Search', section: 'Consult' },
    { path: '/hr/leave', label: 'Apply Leave', section: 'Self' },
    { path: '/lab/orders', label: 'Lab Orders', section: 'Diagnostics' },
    { path: '/hms/radiology', label: 'Radiology', section: 'Diagnostics' },
    { path: '/ipd/list', label: 'My IP Patients', section: 'Inpatient' },
    { path: '/hms/discharge', label: 'Discharge Summary', section: 'Inpatient' },
    { path: '/hms/ot', label: 'OT Management', section: 'Surgical' },
    { path: '/hms/maintenance', label: 'Report Issue', section: 'Facility' },
  ],
  billing: [
    { path: '/billing/receipts', label: 'All Receipts', section: 'Finance' },
    { path: '/billing/op', label: 'OP Billing', section: 'Finance' },
    { path: '/hr/leave', label: 'Apply Leave', section: 'Self' },
    { path: '/hms/maintenance', label: 'Report Issue', section: 'Facility' },
    { path: '/hms/analysis', label: 'Reports', section: 'Finance' },
    { path: '/hms/tpa', label: 'TPA / Insurance', section: 'Finance' },
  ],
  ipd: [
    { path: '/ipd/list', label: 'IPD List', section: 'Inpatient' },
    { path: '/ipd/admit', label: 'Admit Patient', section: 'Inpatient' },
    { path: '/ipd/beds', label: 'Beds', section: 'Inpatient' },
    { path: '/hr/leave', label: 'Apply Leave', section: 'Self' },
    { path: '/hms/discharge', label: 'Discharge Summary', section: 'Inpatient' },
    { path: '/hms/diet', label: 'Diet Orders', section: 'Inpatient' },
    { path: '/hms/ot', label: 'OT Management', section: 'Inpatient' },
    { path: '/hms/maintenance', label: 'Report Issue', section: 'Facility' },
    { path: '/hms/housekeeping', label: 'Cleaning Request', section: 'Facility' },
  ],
  nurse: [
    { path: '/nurse/station', label: 'Nursing Station', section: 'Care' },
    { path: '/ipd/list', label: 'IPD Patients', section: 'Care' },
    { path: '/hr/leave', label: 'Apply Leave', section: 'Self' },
    { path: '/hms/emr', label: 'EMR (view)', section: 'Care' },
    { path: '/hms/diet', label: 'Diet & Meals', section: 'Care' },
    { path: '/hms/bloodbank', label: 'Blood Bank', section: 'Care' },
    { path: '/hms/maintenance', label: 'Report Issue', section: 'Care' },
    { path: '/hms/housekeeping', label: 'Cleaning Request', section: 'Care' },
  ],
  pharmacy: [
    { path: '/pharmacy/desk', label: 'Pharmacy Desk', section: 'Pharmacy' },
    { path: '/hr/leave', label: 'Apply Leave', section: 'Self' },
    { path: '/hms/store', label: 'Central Store', section: 'Pharmacy' },
    { path: '/billing/receipts', label: 'Receipts', section: 'Pharmacy' },
  ],
  lab: [
    { path: '/lab/orders', label: 'Lab Orders', section: 'Laboratory' },
    { path: '/hms/radiology', label: 'Radiology', section: 'Laboratory' },
    { path: '/hr/leave', label: 'Apply Leave', section: 'Self' },
    { path: '/reception/patients', label: 'Patients', section: 'Laboratory' },
  ],
  hr: [
    { path: '/hr/dashboard', label: 'HR Dashboard', section: 'People' },
    { path: '/hr/leave', label: 'Leave Management', section: 'People' },
    { path: '/hms/roster', label: 'Duty Roster', section: 'People' },
  ],
  housekeeping: [
    { path: '/hms/housekeeping', label: 'Cleaning Board', section: 'Today' },
    { path: '/hms/maintenance', label: 'Report Facility Issue', section: 'Today' },
    { path: '/hr/leave', label: 'Apply Leave', section: 'Self' },
  ],
};


export function canAccess(role, pathPattern, roleModuleAccess = {}) {
  const r = normalizeRole(role);
  if (r === 'manager') return true;
  const base = pathPattern.split('/').slice(0, 3).join('/');
  const routeRules = ROUTE_ACCESS[pathPattern] || ROUTE_ACCESS[base];
  if (pathPattern.startsWith('/hms/')) {
    const id = pathPattern.split('/')[2];
    const disabled = new Set(roleModuleAccess[r]?.disabledModules || []);
    if (disabled.has(id)) return false;
    const mod = HMS_MODULES.find((m) => m.id === id);
    const hmsOk = mod ? mod.roles.includes(r) : false;
    const routeOk = routeRules ? routeRules.includes(r) : false;
    return hmsOk || routeOk;
  }
  return routeRules ? routeRules.includes(r) : false;
}

/** Unknown roles get limited reception access — never auto-elevate to manager. */
export function normalizeRole(role) {
  if (role && ROLES[role]) return role;
  return 'reception';
}

export function canDischargePatient(role) {
  const r = normalizeRole(role);
  return r === 'manager' || r === 'ipd' || r === 'doctor' || r === 'billing';
}

export function canMergePatients(role) {
  const r = normalizeRole(role);
  return r === 'manager' || r === 'reception';
}

export function landingPathFor(role) {
  return ROLES[normalizeRole(role)]?.landing || '/manager/dashboard';
}

export function roleLabelFor(role) {
  return ROLES[normalizeRole(role)]?.label || role || 'Staff';
}

export function getNavItems(role, roleModuleAccess = {}) {
  const r = normalizeRole(role);
  const items = NAV_BY_ROLE[r] || NAV_BY_ROLE.manager;
  if (r === 'manager') return items;
  const disabled = new Set(roleModuleAccess[r]?.disabledModules || []);
  return items.filter((item) => {
    if (item.path.startsWith('/hms/')) {
      const modId = item.path.split('/')[2];
      return !disabled.has(modId);
    }
    const mod = HMS_MODULES.find((m) => item.path === m.path || item.path.startsWith(m.path));
    if (mod) return !disabled.has(mod.id);
    return true;
  });
}
